import { VStack, HStack, Text, Input } from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface IDateRangePickerProps {
  startDate?: Date;
  endDate?: Date;
  onStartChange: (date: Date | null) => void;
  onEndChange: (date: Date | null) => void;
}

export const DateRangePicker = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
}: IDateRangePickerProps): JSX.Element => (
  <VStack spacing={2} align="stretch">
    <HStack spacing={2}>
      <Text fontSize="sm" color="gray.400" minW="30px">
        de:
      </Text>

      <DatePicker
        selected={startDate}
        onChange={onStartChange}
        dateFormat="dd/MM/yyyy"
        customInput={<Input size="sm" />}
        selectsStart
        startDate={startDate}
        endDate={endDate}
      />
    </HStack>

    <HStack spacing={2}>
      <Text fontSize="sm" color="gray.400" minW="30px">
        até:
      </Text>

      <DatePicker
        selected={endDate}
        onChange={onEndChange}
        dateFormat="dd/MM/yyyy"
        minDate={startDate}
        customInput={<Input size="sm" />}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
      />
    </HStack>
  </VStack>
);
